const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadypages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "480,110 480,480 110,480 110,425 280,425 280,147.5 202.5,70 110,70 110,10 380,10      380,110    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f7fcff"
    },
    points: "480,110 380,110 380,10    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "280,147.5 280,425 110,425 10,425 10,70 110,70 202.5,70 202.5,147.5    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f7fcff"
    },
    points: "280,147.5 202.5,147.5 202.5,70    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M489.976,110c-0.001-2.602-0.993-5.158-2.905-7.071l-100-100c-1.913-1.912-4.47-2.903-7.071-2.904     V0H110c-5.523,0-10,4.477-10,10v50H10C4.477,60,0,64.478,0,70v355c0,5.522,4.477,10,10,10h90v45c0,5.522,4.477,10,10,10h370     c5.523,0,10-4.478,10-10V110H489.976z M390,34.143L455.858,100H390V34.143z M20,80h172.5v67.5c0,5.523,4.477,10,10,10H270V415H20     V80z M212.5,94.143l43.357,43.357H212.5V94.143z M120,470v-35h160c5.523,0,10-4.478,10-10V147.5c0-2.652-1.054-5.195-2.929-7.071     l-77.5-77.5C207.696,61.054,205.152,60,202.5,60H120V20h250v90c0,5.522,4.477,10,10,10h90v350H120z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    style: {
      fill: "#ffffff"
    },
    width: 130,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 220,
    style: {
      fill: "#ffffff"
    },
    width: 130,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 280,
    style: {
      fill: "#ffffff"
    },
    width: 130,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 340,
    style: {
      fill: "#ffffff"
    },
    width: 130,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 400,
    style: {
      fill: "#ffffff"
    },
    width: 130,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 105,
    style: {
      fill: "#ffffff"
    },
    width: 65,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 145,
    style: {
      fill: "#ffffff"
    },
    width: 65,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 205,
    style: {
      fill: "#ffffff"
    },
    width: 200,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 255,
    style: {
      fill: "#ffffff"
    },
    width: 200,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 305,
    style: {
      fill: "#ffffff"
    },
    width: 200,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 355,
    style: {
      fill: "#ffffff"
    },
    width: 200,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadypages);
export default __webpack_public_path__ + "static/media/readypages.7b61100c3c31bcb2451bc4fe4b1b1baa.svg";
export { ForwardRef as ReactComponent };